// coreHeaders — auth headers for the handful of direct `fetch()` calls that
// still predate an SDK route. Everything else goes through
// `sdk.execute(entity, op, args)`. (Renamed from supabaseConfig.js when the
// Supabase plane was removed; the name was the last thing left of it.)
//
// The file is ONLY the `coreHeaders` helper. Its old URL exports are gone:
// the governance Supabase project was removed (RAW_SUPABASE_URL / SUPABASE_KEY
// / SUPABASE_ANON_KEY / workspaceExtensionSessionAccessToken /
// edgeFunctionHeaders / supabaseFetchConfig / getSupabaseRealtimeClient), and
// so are SUPABASE_URL + edgeFunctionUrl() — nothing addressed either any more.
// agent_presence / agent_activity_log moved to Mongo on 2026-07-03 and read
// through /core/agent-presence + /core/agent-activity; the calendar-sync and
// github-sync edge functions were deleted outright.
//
// The name is kept for import stability across the packages that consume it.

// `restHeaders()` — the bearer helper for direct /workspace-project/sb/*
// passthrough fetches — was REMOVED 2026-07-27, and the `/sb` proxy itself is
// deleted (404). Do NOT re-add a raw-fetch helper; SDK-only backend access is
// the rule.

// Headers for MAIN-API (/core/*) fetches. LIVE — three callers:
// tickets/functions/fetchGeneralTriage.js, tickets/functions/fetchActivityFeed.js,
// canvas/pages/team-and-agents.js. (shared/functions/systemStatus.js reads
// through the SDK now — DESIGN-SHARED-SYSTEMSTATUS-RAW-FETCH-ONTO-SDK-1.)
// Sends ONLY the SDK bearer: the Supabase `apikey` header is NOT in the API's
// CORS allowedHeaders (Content-Type/Authorization/X-AppKey), so reusing it
// against dev.api.symbols.app fails the preflight with a bare "Failed to fetch"
// (hit by the 2026-07-03 __USE_CORE_AGENT_PRESENCE__/_ACTIVITY_ default-ON
// flips). No anon-key fallback — /core routes want the SDK token or nothing.
//
// FA204 / frank trap — `_sdkAccessToken` used to be a bare module-scope
// helper, read from inside this exported function's own body: unresolvable
// once this file's exports are individually frank.toJSON'd for platform
// delivery (project_frank_drops_module_local_helpers). Inlined as a local —
// no other export in this file needs it.
export const coreHeaders = () => {
  // Resolve the user's SDK Mongo access token. The main API verifies it via
  // HS256 and resolves workspace context through its userResolver, which
  // reads `User.activeOrganization` LIVE from Mongo every request — so an
  // org-switch or workspace-rename takes effect immediately. null outside
  // the browser or when no token is present.
  const sdkAccessToken = () => {
    if (typeof window === 'undefined') return null
    try {
      return window.localStorage.getItem('symbols_access_token')
    } catch {
      return null
    }
  }
  const token = sdkAccessToken()
  return token ? { Authorization: `Bearer ${token}` } : {}
}
